/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  convertQueryStringToParams.js
 */

/**
 * convert query-string (aka location.search) String to url params
 *
 * @param {string} query location.search
 * @returns query object similar to https://expressjs.com/en/api.html#req.query
 */
export const convertQueryStringToParams = (query?: string) => {
  const queryObj: { [k: string]: string | string[] } = {}
  if (query) {
    const queryString = query[0] === '?' ? query.substr(1) : query
    const params = queryString.split('&')
    for (const param of params) {
      const pair = param.split('=')
      if (!pair[0]) {
        continue
      }
      let value: string
      if (pair[1] === undefined) {
        value = 'true'
      } else {
        try {
          value = decodeURIComponent(pair[1])
        } catch {
          value = 'true'
        }
      }
      const existingValue = queryObj[pair[0]]
      if (typeof existingValue === 'undefined') {
        queryObj[pair[0]] = value
        // If second entry with this name
      } else if (typeof existingValue === 'string') {
        queryObj[pair[0]] = [existingValue, value]
        // If third or later entry with this name
      } else {
        existingValue.push(value)
      }
    }
  }
  return queryObj
}
